const PRIORITY_COLORS = {
  URGENTE: 'red',
  NORMAL: 'blue',
  BAJA: 'grey'
}

const PRIORITY_ICONS = {
  URGENTE: 'priority_high',
  NORMAL: 'notifications',
  BAJA: 'info'
}

const PRIORITY_LABELS = {
  URGENTE: 'Urgente',
  NORMAL: 'Normal',
  BAJA: 'Baja'
}

export function getPriorityColor(priority) {
  return PRIORITY_COLORS[priority] || 'blue'
}

export function getPriorityIcon(priority) {
  return PRIORITY_ICONS[priority] || 'info'
}

export function getPriorityDisplay(priority) {
  return PRIORITY_LABELS[priority] || priority
}

export function formatMessageDate(dateStr) {
  if (!dateStr) return '-'
  try {
    const date = new Date(dateStr)
    return date.toLocaleDateString('es-MX') + ' ' + date.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })
  } catch (e) {
    return dateStr
  }
}
